import type { SharedFormFieldProps } from '../contexts/FormFieldContext.js';

/**
 * @public
 */
export const enum FormFieldAction {
  UPDATE = 'update',
}

/**
 * @public
 */
export type FormFieldReducerActionPayload = {
  id?: string;
  disabled?: boolean;
  required?: boolean;
  ariaDisabled?: boolean;
};

/**
 * @public
 */
export type FormFieldReducerAction = {
  type: FormFieldAction.UPDATE;
  payload: FormFieldReducerActionPayload;
};

/**
 * @internal
 * FormField reducer function used for managing the FormField state.
 */
export function _formFieldReducer(
  state: SharedFormFieldProps,
  action: FormFieldReducerAction,
): SharedFormFieldProps {
  const { type, payload } = action;

  if (type === FormFieldAction.UPDATE) {
    return {
      controlId: payload.id || state.controlId,
      required:
        payload.required !== undefined ? payload.required : state.required,
      disabled:
        payload.disabled !== undefined ? payload.disabled : state.disabled,
      ariaDisabled:
        payload.ariaDisabled !== undefined
          ? payload.ariaDisabled
          : state.ariaDisabled,
    };
  }

  return state;
}
